/* eslint-disable */
import React, { useEffect } from 'react';
import { Footer, Main, Sidebar, FullLoader, Header } from 'components';
import { useDispatch, useSelector } from 'react-redux';
import { TIPO_ACCESO_WEB } from 'constants/tiposAcceso';
import { getAllCatalogos } from 'actions/catalogos.actions';
import { selectAuthState } from 'selectors/auth.selector';
import { initApp } from 'actions/auth.actions';
import { useNavigate } from 'react-router-dom';

const Layout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { isStarted } = useSelector(selectAuthState);
  // const loading = useSelector(selectMenuState);

  useEffect(() => {
    const respuesta = async () => {
      const { success } = await dispatch(initApp());
      if (success !== 200) {
        if (!process.env.REACT_APP_IS_LOCAL) {
          window.location.href = 'process.env.REACT_IS_NOT_LOCAL';
        }
        // window.location.href = 'https://sifv6-test.ine.mx/loginUTF/'; // pruebas
        // window.location.href = 'https://sifv6-usu-test.ine.mx/loginUTF/'; // usu
      }
      if (success !== 200) {
        const ruta = '/autenticacion';
        navigate(ruta);
      }
    };
    respuesta();
  }, []);

  useEffect(() => {
    if (isStarted) 
    {
      // MNI - Se comenta para hacer pruebas
      dispatch(getAllCatalogos({ tipoAcceso: TIPO_ACCESO_WEB }));
    }
  }, [isStarted]);

  if (!isStarted) return <FullLoader />;

  return (
    <>
      <Header />
      <Main>
        <Sidebar />
      </Main>
      <Footer />
    </>
  );
};

export default Layout;
